import React from 'react';
import { logger } from '@lib/common';
import { SelectAsync } from '../../form/select.async';
export class InputAddress extends React.PureComponent {
    timer;
    loadOptions = async (input) => {
        const { type, gm, mb, googleMaps } = this.props;
        if (type === 'osm') {
            try {
                const result = await mb.geocode_autocomplete(input, {
                    types: 'address,poi',
                });
                return result.features.map(p => ({
                    ...p,
                    value: p.place_name,
                    label: p.place_name,
                }));
            }
            catch (e) {
                if (!e || e.message !== 'Not Found') {
                    logger.captureException(e);
                }
                this.props.onError(typeof e === 'string' ? e : 'Error finding location data');
                return [];
            }
        }
        else {
            try {
                const predictions = await googleMaps.autocomplete_place({
                    input: input,
                    restaurantId: googleMaps.restaurantId
                });
                return predictions
                    .map(p => ({
                    ...p,
                    place_id: p.place_id,
                    value: p.description,
                    label: p.description,
                }))
                    .filter(p => !!p.place_id);
            }
            catch (e) {
                if (e !== 'Nothing found') {
                    logger.captureException(e);
                }
                this.props.onError(typeof e === 'string' ? e : 'Error finding location data');
                return [];
            }
        }
    };
    onChange = async (value) => {
        const { type, gm, googleMaps } = this.props;
        if (!value) {
            this.props.onError(null);
            return;
        }
        if (type === 'osm') {
            value = value;
            const components = {};
            for (const c of value.context) {
                const key = c.id.split('.')[0];
                if (key === 'region') {
                    components['administrative_area_level_1'] = c.text;
                    continue;
                }
                if (key === 'postcode') {
                    components['postal_code'] = c.text;
                    continue;
                }
                components[key] = c.text;
            }
            if (value.address) {
                components['street_number'] = value.address;
            }
            if (value.text) {
                components['route'] = value.text;
            }
            const requiredFields = [
                "route",
                "locality",
                "administrative_area_level_1",
                "postal_code",
                "country",
                "street_number",
            ];
            for (const field of requiredFields) {
                if (!components[field]) {
                    components[field] = '';
                }
            }
            this.props.onChange(value.place_name, {
                type: 'osm',
                components: components,
                lng: value.center[0],
                lat: value.center[1],
            });
        }
        else {
            try {
                value = value;
                const place = await googleMaps.place_get({
                    placeId: value.place_id
                });
                if (!place.geometry || !place.address_components || !place.formatted_address) {
                    throw new Error(`Missing geometry for ${value.value}`);
                }
                const componentForm = {
                    street_number: 'short_name',
                    route: 'long_name',
                    locality: 'long_name',
                    administrative_area_level_1: 'short_name',
                    country: 'long_name',
                    postal_code: 'short_name',
                };
                const components = {};
                for (const component of place.address_components) {
                    const t = component.types[0];
                    if (componentForm[t]) {
                        components[t] = component[componentForm[t]];
                    }
                }
                this.props.onChange(place.formatted_address, {
                    type: 'google_maps',
                    components: components,
                    //@ts-ignore
                    lat: place.geometry.location.lat,
                    //@ts-ignore
                    lng: place.geometry.location.lng,
                });
            }
            catch (e) {
                logger.captureException(e);
                this.props.onError(typeof e === 'string' ? e : 'Error finding data on selected location');
            }
        }
    };
    render() {
        return (React.createElement(SelectAsync, { value: this.props.value, fetch: this.loadOptions, onChange: this.onChange }));
    }
}
//# sourceMappingURL=index.js.map